// Errors bubbled up from scripts injected by in-app browser JS bridges (Zalo,
// Facebook, etc.) that reference their own globals before they exist. These
// throw a global `onerror` our SDKs capture, but the frame resolves to the
// bare document (`<!doctype html>`) — no first-party code is involved, so they
// are pure noise. Match by the injected global name to avoid dropping real
// ReferenceErrors from our own bundle. Shared by Sentry and PostHog so both
// drop the same errors.
export const IGNORED_ERRORS: RegExp[] = [
    // Zalo in-app browser bridge global (iOS WKWebView and Android WebView).
    /zaloJSV2/,
]

interface ExceptionEntry {
    type?: string
    value?: string
}

/** True when a PostHog `$exception` event only reports ignored errors. */
export function isIgnoredException(event: {
    event: string
    properties: Record<string, unknown>
}): boolean {
    if (event.event !== '$exception') return false
    const list = event.properties.$exception_list
    if (!Array.isArray(list) || list.length === 0) return false
    return list.every((entry: ExceptionEntry) => {
        const message = `${entry.type}: ${entry.value}`
        return IGNORED_ERRORS.some((pattern) => pattern.test(message))
    })
}
